import { TableLoader } from "../../Common/ShimmerLoader";
import {
  HistoryStatusBadge,
  formatRfidDateTime,
} from "./utils/statusBadge";

const HISTORY_COLUMNS = [
  "S.No",
  "Status",
  "Remarks",
  "Action Taken By",
  "Modified On",
];

const RfidHistoryTable = ({
  history = [],
  isLoading = false,
  subThStyle,
  subTdStyle,
  subStatusThStyle,
  subStatusTdStyle,
}) => {
  if (isLoading && !history.length) {
    return <TableLoader rows={4} columns={5} height={180} />;
  }

  if (!history.length) {
    return (
      <div style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            maxWidth: 900,
            borderCollapse: "collapse",
            textAlign: "left",
            fontSize: "13px",
          }}
        >
          <tbody>
            <tr>
              <td
                colSpan={HISTORY_COLUMNS.length}
                style={{ ...subTdStyle, textAlign: "center" }}
              >
                No history available
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table
        style={{
          width: "100%",
          maxWidth: 900,
          borderCollapse: "collapse",
          textAlign: "center",
          fontSize: "13px",
        }}
      >
        <thead>
          <tr>
            {HISTORY_COLUMNS.map((col) => (
              <th
                key={col}
                style={col === "Status" ? subStatusThStyle : subThStyle}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {history.map((item, index) => (
            <tr key={`${item.sNo ?? index}-${item.modifiedOn}`}>
              <td style={subTdStyle}>{item.sNo ?? index + 1}</td>
              <td style={subStatusTdStyle}>
                <HistoryStatusBadge statusName={item.statusName} compact />
              </td>
              <td style={subTdStyle}>{item.remarks}</td>
              <td style={subTdStyle}>{item.actionTakenBy}</td>
              <td style={subTdStyle}>
                {formatRfidDateTime(item.modifiedOn)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RfidHistoryTable;
